import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  EcommerceWebProcessKickoff,
  EcommerceWebProcessStack,
  EcommerceWebProcessUIUX,
  EcommerceWebProcessFrontend,
  EcommerceWebProcessQuality,
  EcommerceWebProcessLaunch,
  CRMDevelopersProcessSupport,
} from "../../../app-constants";
import { WoocommerceIntegerations } from "../../../app-constants-updated";
import { Link } from "gatsby";

function Ecommercewebprocess() {
  return (
    <section
      className="ecommerce_web_process woocommerce-web-process p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Our Precision <span>WooCommerce Development</span> Workflow
            </h2>
            <p>
              Our WooCommerce web development services follow a lean process. As
              a WooCommerce web design and development company, we focus on each
              phase's technical and functional aspects to build a
              high-performance, scalable solution that appeals to users and
              drives conversions.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  01
                  <h5>Project Kick-Off</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessKickoff}
                </div>
              </div>
              <p>
                Define technical requirements and set clear development
                objectives with our team.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  02
                  <h5>Technology Stack Selection</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessStack}</div>
              </div>
              <p>
                Select the optimal tech stack tailored to your WooCommerce
                project’s specific needs.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  03
                  <h5>UI/UX Design</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessUIUX}</div>
              </div>
              <p>
                Design a user interface focused on functionality, navigation,
                and user engagement.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  04
                  <h5>Backend Development</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessFrontend}
                </div>
              </div>
              <p>
                Develop and implement backend systems with precise coding and
                architecture.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  05
                  <h5>Integration & Performance Optimization</h5>
                </div>
                <div className="ecom_box_icon">{WoocommerceIntegerations}</div>
              </div>
              <p>
                Integrate essential plugins and APIs while optimizing for speed
                and scalability.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  06
                  <h5>Rigorous Testing & Quality Assurance</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessQuality}
                </div>
              </div>
              <p>
                Execute thorough testing protocols to ensure code integrity and
                system security.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-md-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  07
                  <h5>Launch & Deployment</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessLaunch}</div>
              </div>
              <p>
                Deploy the WooCommerce site with precision, ensuring full
                functionality and readiness.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  08
                  <h5>Ongoing Support & Maintenance</h5>
                </div>
                <div className="ecom_box_icon">
                  {CRMDevelopersProcessSupport}
                </div>
              </div>
              <p>
                Deliver continuous updates and technical support to maintain
                optimal performance.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center text-center">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-5"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Talk to Our Experts
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommercewebprocess;
